<style scoped>
table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}

td.even {
    background-color: lightgray;
}

.monitoring-summary {
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    padding: 12px 16px;
    background: #fafafa;
}

.monitoring-summary-item + .monitoring-summary-item {
    margin-top: 6px;
}

.monitoring-warehouse-select :deep(.vs__dropdown-toggle) {
    min-height: 42px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 6px;
}

.monitoring-warehouse-select :deep(.vs__selected-options) {
    padding: 2px 6px;
}

.monitoring-warehouse-select :deep(.vs__search) {
    margin: 0;
}

/* Extra spacing between filter fields and action buttons */
.inspection-filter-row .flex.flex-wrap {
    margin-top: 8px;
}

/* Inspection — Arah 2: Warehouse Ops */
.inspection-tab .ops-actions {
    display: flex;
    gap: 8px;
}

.inspection-tab .ops-filter {
    padding: 14px 16px;
    margin-bottom: 18px;
    background: #fff;
    border: 1px solid #dbe3ec;
    border-radius: 6px;
    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04);
}

.inspection-tab .ops-filter .vs-input--label {
    color: #64748b;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
}

.inspection-tab .ops-filter :deep(.vs__dropdown-toggle),
.inspection-tab .ops-filter .flatpickr-input {
    box-sizing: border-box;
    background: #fff;
    border: 1px solid #dbe3ec !important;
    border-radius: 4px;
}

.inspection-tab .ops-filter :deep(.vs__dropdown-toggle:hover),
.inspection-tab .ops-filter :deep(.vs__dropdown-toggle:focus),
.inspection-tab .ops-filter :deep(.vs__dropdown-toggle:focus-within),
.inspection-tab .ops-filter .flatpickr-input:focus {
    border-color: #dbe3ec !important;
    box-shadow: none !important;
}

.inspection-tab .ops-filter .vx-col {
    display: flex !important;
    align-items: center !important;
    height: 28px !important;
    min-height: 28px !important;
}

.inspection-tab .ops-filter .flatpickr-input {
    height: 26px !important;
    min-height: 26px !important;
    padding: 0 8px !important;
    line-height: 26px !important;
    box-sizing: border-box !important;
}

.inspection-tab .ops-filter-actions {
    display: flex;
    gap: 6px;
    align-items: center;
}

.inspection-tab .ops-summary {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 18px;
}

.inspection-tab .ops-summary-card {
    padding: 16px 18px;
    background: #fff;
    border: 1px solid #dbe3ec;
    border-radius: 6px;
    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04);
}

.inspection-tab .ops-product {
    margin-bottom: 14px;
    color: #0f172a;
    font-size: 14px;
    font-weight: 800;
}

.inspection-tab .ops-metrics {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.inspection-tab .ops-metric {
    padding-left: 10px;
    border-left: 2px solid #cbd5e1;
}

.inspection-tab .ops-metric.inspected { border-left-color: #2563eb; }
.inspection-tab .ops-metric.ready { border-left-color: #16a34a; }
.inspection-tab .ops-metric.accumulated { border-left-color: #d97706; }

.inspection-tab .ops-label {
    display: block;
    margin-bottom: 4px;
    color: #64748b;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
}

.inspection-tab .ops-value {
    color: #0f172a;
    font-size: 24px;
    font-weight: 800;
    line-height: 1.1;
    font-variant-numeric: tabular-nums;
}

.inspection-tab .ops-table-wrap {
    overflow-x: auto;
    border: 1px solid #dbe3ec;
    border-radius: 6px;
    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04);
}

.inspection-tab .ops-table {
    width: 100%;
    min-width: 560px;
    border-collapse: collapse;
    background: #fff;
}

.inspection-tab .ops-table,
.inspection-tab .ops-table th,
.inspection-tab .ops-table td {
    border: none !important;
}

.inspection-tab .ops-table th {
    padding: 10px 14px;
    background: #eef1f5;
    border-bottom: 1px solid #dbe3ec;
    color: #64748b;
    font-size: 11px;
    font-weight: 700;
    text-align: left;
    text-transform: uppercase;
    white-space: nowrap;
}

.inspection-tab .ops-table th.numeric,
.inspection-tab .ops-table td.numeric {
    text-align: right;
}

.inspection-tab .ops-table td {
    padding: 10px 14px;
    border-bottom: 1px solid #eef1f5;
    color: #334155;
    font-size: 13px;
}

.inspection-tab .ops-table tbody tr:nth-child(even) td {
    background: #f8fafc;
}

.inspection-tab .ops-table tbody tr:last-child td {
    border-bottom: 0;
}

.inspection-tab .ops-table td.product {
    color: #0f172a;
    font-weight: 700;
}

.inspection-tab .ops-empty {
    padding: 40px 20px;
    color: #64748b;
    text-align: center;
}

@media (max-width: 768px) {
    .inspection-tab .ops-header {
        align-items: flex-start;
    }

    .inspection-tab .ops-actions {
        width: 100%;
        margin-top: 10px;
    }

    .inspection-tab .ops-actions .vs-button {
        flex: 1;
    }

    .inspection-tab .ops-summary {
        grid-template-columns: 1fr;
    }

    .inspection-tab .ops-metrics {
        grid-template-columns: 1fr;
        gap: 8px;
    }
}
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <vs-tabs v-model="activeTab">
                <vs-tab label="Stock"></vs-tab>
                <vs-tab label="Daily"></vs-tab>
                <vs-tab label="Inspection"></vs-tab>
            </vs-tabs>

            <!-- Stock Tab -->
            <div v-if="activeTab === 0">
                <div class="flex flex-wrap items-center justify-between mb-4">
                    <div class="flex items-center ml-1">
                        <h4>Monitoring - Stock</h4>
                        <div style="margin-left: 10px">
                            <strong>Last updated at: {{ lastUpdated }}</strong>
                        </div>
                    </div>
                    <div class="flex items-center">
                        <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh" :disabled="isLoading">Refresh</vs-button>
                        <vs-button @click="handleExport" class="btn mb-4 md:mb-0 mr-1" icon="import_export" :disabled="isExporting">Export</vs-button>
                    </div>
                </div>
                <div class="flex flex-wrap items-end -mx-2 mb-4">
                    <div class="w-full md:w-1/4 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Select Warehouse</label>
                        <v-select
                            :key="warehouseSelectKey"
                            ref="warehouseSelect"
                            class="monitoring-warehouse-select"
                            v-model="warehouse_ids"
                            :options="warehouses"
                            :reduce="(item) => item.id"
                            label="name"
                            multiple
                            placeholder="All Warehouses"
                            :close-on-select="false"
                        >
                            <template v-slot:search="{ attributes, events }">
                                <input class="vs__search" v-bind="attributes" v-on="events" :placeholder="warehouse_ids.length ? '' : 'All Warehouses'" />
                            </template>
                        </v-select>
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Start Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="start_date" />
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">End Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="end_date" />
                    </div>
                    <div class="w-full md:w-auto px-2">
                        <div class="flex flex-wrap mt-2">
                            <vs-button class="btn w-full md:w-auto mr-0 md:mr-1 mb-2 md:mb-0" icon="filter_list" @click="applyFilters">Filter</vs-button>
                            <vs-button class="btn w-full md:w-auto" color="warning" icon="refresh" @click="resetFilters">Reset</vs-button>
                        </div>
                    </div>
                </div>
                <div class="monitoring-summary mb-4">
                    <strong>Total Filtered Warehouses :</strong>
                    <div v-if="totalPerProduct.length" class="mt-2">
                        <div v-for="item in totalPerProduct" :key="item.product_code" class="monitoring-summary-item">
                            {{ item.product_code }} : {{ formatQty(item.total_inventory_qty) }}
                        </div>
                    </div>
                    <div v-else class="mt-2 text-muted">No data available</div>
                </div>
                <table class="table w-full border border-gray-300">
                    <thead>
                        <tr>
                            <th class="text-center" rowspan="2">Tanggal</th>
                            <th class="text-center" rowspan="2">Warehouse</th>
                            <th class="text-center" rowspan="2">Product Code</th>
                            <th class="text-center" rowspan="2">Beginning QTY</th>
                            <th class="text-center" colspan="2">In QTY</th>
                            <th class="text-center" colspan="2">Out QTY</th>
                            <th class="text-center" rowspan="2">End QTY</th>
                        </tr>
                        <tr>
                            <th class="text-center">Inbound</th>
                            <th class="text-center">TWH In</th>
                            <th class="text-center">Outbound</th>
                            <th class="text-center">TWH Out</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(group, index) in tableData">
                            <tr :key="`index-${index}-${trIndex}`" v-for="(tr, trIndex) in group">
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''" :rowspan="group.length" v-if="trIndex == 0">{{ group[0].date }}</td>
                                <td class="text-center" :rowspan="group.length" :class="index % 2 === 0 ? 'even' : ''" v-if="trIndex == 0">{{ group[0].warehouse.name }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ tr.product.product_code }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.initial_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.inbound_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.twh_in_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.outbound_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.twh_out_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.inventory_qty) }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <vs-pagination class="mt-4" :total="totalPage" v-model="currentPage" @change="handleStockPageChange"></vs-pagination>

            </div>

            <!-- Daily Tab -->
            <div v-else-if="activeTab === 1">
                <div class="flex flex-wrap items-center justify-between mb-4">
                    <div class="flex items-center ml-1">
                        <h4>Daily Movement - All Warehouses</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button @click="fetchMovement" class="btn mb-4 md:mb-0 mr-1" icon="refresh" :disabled="isLoading">Refresh</vs-button>
                        <vs-button @click="handleMovementExport" class="btn mb-4 md:mb-0 mr-1" icon="import_export" :disabled="isMovementExporting">Export</vs-button>
                    </div>
                </div>
                <div class="flex flex-wrap items-end -mx-2 mb-4">
                    <div class="w-full md:w-1/4 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Select Product</label>
                        <v-select
                            class="monitoring-warehouse-select"
                            v-model="movementProductCodes"
                            :options="movementProducts"
                            multiple
                            placeholder="All Products"
                            :close-on-select="false"
                        >
                            <template v-slot:search="{ attributes, events }">
                                <input class="vs__search" v-bind="attributes" v-on="events" :placeholder="movementProductCodes.length ? '' : 'All Products'" />
                            </template>
                        </v-select>
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Start Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="movementStartDate" />
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">End Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="movementEndDate" />
                    </div>
                    <div class="w-full md:w-auto px-2">
                        <div class="flex flex-wrap mt-2">
                            <vs-button class="btn w-full md:w-auto mr-0 md:mr-1 mb-2 md:mb-0" icon="filter_list" @click="applyMovementFilter">Filter</vs-button>
                            <vs-button class="btn w-full md:w-auto" color="warning" icon="refresh" @click="resetMovementFilter">Reset</vs-button>
                        </div>
                    </div>
                </div>
                <div class="monitoring-summary mb-4">
                    <strong>Total Accumulated :</strong>
                    <div v-if="movementTotalAccumulated.length" class="mt-2">
                        <div v-for="item in movementTotalAccumulated" :key="item.product_code" class="monitoring-summary-item">
                            {{ item.product_code }} : Total Inbound {{ formatQty(item.total_inbound_qty) }} | Total Outbound {{ formatQty(item.total_outbound_qty) }} | Sisa Stock : {{ formatQty(item.total_stock_qty) }}
                        </div>
                    </div>
                    <div v-else class="mt-2 text-muted">No data available</div>
                </div>
                <table class="table w-full border border-gray-300">
                    <thead>
                        <tr>
                            <th class="text-center">Tanggal</th>
                            <th class="text-center">Product Code</th>
                            <th class="text-center">Inbound</th>
                            <th class="text-center">Outbound</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(group, index) in movementData">
                            <tr :key="`movement-${index}-${trIndex}`" v-for="(tr, trIndex) in group">
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''" :rowspan="group.length" v-if="trIndex == 0">{{ group[0].date }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ tr.product_code }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.inbound_qty) }}</td>
                                <td class="text-center" :class="index % 2 === 0 ? 'even' : ''">{{ formatQty(tr.outbound_qty) }}</td>
                            </tr>
                        </template>
                        <tr v-if="!movementData.length">
                            <td class="text-center" colspan="4">No data available</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Inspection Tab -->
            <div v-else-if="activeTab === 2" class="inspection-tab">
                <div class="flex flex-wrap items-center justify-between mb-4 ops-header">
                    <h4>Monitoring - Inspection</h4>
                    <div class="ops-actions">
                        <vs-button icon="refresh" :disabled="isLoading" @click="refreshInspection">Refresh</vs-button>
                        <vs-button icon="import_export" :disabled="isInspectionExporting" @click="handleInspectionExport">Export</vs-button>
                    </div>
                </div>
                <div class="ops-filter">
                    <div class="flex flex-wrap items-end -mx-2 inspection-filter-row">
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Product Code</label>
                        <v-select
                            v-model="inspectionFilter.product_code"
                            :options="inspectionProducts"
                            label="product_code"
                            placeholder="All Products"
                            :clearable="true"
                        >
                            <template v-slot:search="{ attributes, events }">
                                <input class="vs__search" v-bind="attributes" v-on="events" :placeholder="inspectionFilter.product_code ? '' : 'All Products'" />
                            </template>
                        </v-select>
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">Start Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="inspectionFilter.start_date" placeholder="Start Date" />
                    </div>
                    <div class="w-full md:w-1/5 px-2 mb-4 md:mb-0">
                        <label class="vs-input--label">End Date</label>
                        <flat-pickr class="w-full p-2 vx-col" v-model="inspectionFilter.end_date" placeholder="End Date" />
                    </div>
                    <div class="w-full md:w-auto px-2">
                        <div class="ops-filter-actions">
                            <vs-button class="btn w-full md:w-auto mr-0 md:mr-1 mb-2 md:mb-0" icon="filter_list" @click="applyInspectionFilters">Filter</vs-button>
                            <vs-button class="btn w-full md:w-auto" color="warning" icon="refresh" @click="resetInspectionFilters">Reset</vs-button>
                        </div>
                    </div>
                    </div>
                </div>
                <div v-if="inspectionSummary.length" class="ops-summary">
                    <div v-for="item in inspectionSummary" :key="item.product_code" class="ops-summary-card">
                        <div class="ops-product">{{ item.product_code }}</div>
                        <div class="ops-metrics">
                            <div class="ops-metric inspected">
                                <span class="ops-label">Inspected</span>
                                <div class="ops-value">{{ formatQty(item.inspected) }}</div>
                            </div>
                            <div class="ops-metric ready">
                                <span class="ops-label">Ready to Ship (RTS)</span>
                                <div class="ops-value">{{ formatQty(item.ready) }}</div>
                            </div>
                            <div class="ops-metric accumulated">
                                <span class="ops-label">Accumulated RTS</span>
                                <div class="ops-value">{{ formatQty(item.accumulated) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="inspectionData.length">
                    <div class="ops-table-wrap">
                        <table class="ops-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Product Code</th>
                                    <th class="numeric">Inspected Qty</th>
                                    <th class="numeric">Ready to Ship</th>
                                    <th class="numeric">Accumulated Ready to Ship</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in inspectionData" :key="row.id">
                                    <td>{{ row.date }}</td>
                                    <td class="product">{{ row.product_code }}</td>
                                    <td class="numeric">{{ formatQty(row.inspected_qty) }}</td>
                                    <td class="numeric">{{ formatQty(row.ready_to_ship) }}</td>
                                    <td class="numeric">{{ formatQty(row.accumulated_ready_to_ship) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <vs-pagination class="mt-4" :total="inspectionTotalPage" v-model="inspectionCurrentPage" @change="handleInspectionPageChange"></vs-pagination>
                </div>
                <div v-else class="ops-empty">No Inspection Data Available</div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import FileSaver from 'file-saver'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css'
import 'vue-select/dist/vue-select.css'

export default {
    name: 'Monitoring',
    components: {
        flatPickr,
        vSelect,
    },
    data() {
        return {
            activeTab: 0,
            isLoading: false,
            isExporting: false,
            isInspectionExporting: false,
            warehouse_ids: [],
            warehouseSelectKey: 0,
            start_date: '',
            end_date: '',
            warehouses: [],
            tableData: [],
            totalPerProduct: [],
            currentPage: 1,
            totalPage: 1,
            limit: 10,
            loadingCount: 0,
            lastUpdated: '-',
            stockLoadedPage: null,
            stockRequestInFlight: false,
            movementData: [],
            movementLoaded: false,
            isMovementExporting: false,
            movementProducts: [],
            movementProductCodes: [],
            movementInitialLoad: true,
            movementTotalAccumulated: [],
            movementStartDate: '',
            movementEndDate: '',
            // Inspection tab
            inspectionData: [],
            inspectionSummary: [],
            inspectionCurrentPage: 1,
            inspectionTotalPage: 1,
            inspectionLoadedPage: null,
            inspectionProducts: [],
            inspectionFilter: {
                product_code: null,
                start_date: '',
                end_date: '',
            },
        }
    },
    watch: {
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        },
        activeTab(val) {
            if (val === 1 && !this.movementLoaded) {
                this.fetchMovement()
            }
            if (val === 2 && !this.inspectionData.length) {
                this.loadInspection()
            }
        },
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        formatQty(value) {
            if (value === null || value === undefined || value === '') {
                return value
            }

            return Number(value).toLocaleString('id-ID')
        },
        setLoading(isStart) {
            if (isStart) {
                this.loadingCount += 1
            } else {
                this.loadingCount = Math.max(0, this.loadingCount - 1)
            }
            this.isLoading = this.loadingCount > 0
        },
        applyFilters() {
            this.currentPage = 1
            this.fetchData()
        },
        getExportWarehouseName() {
            if (!this.warehouse_ids.length) {
                return 'All Warehouses'
            }

            if (this.warehouse_ids.length > 1) {
                return 'Multiple Warehouses'
            }

            const selectedWarehouse = this.warehouses.find(
                (warehouse) =>
                    String(warehouse.id) === String(this.warehouse_ids[0])
            )

            return selectedWarehouse
                ? selectedWarehouse.name
                : this.warehouse_ids[0]
        },
        resetFilters() {
            this.warehouse_ids.splice(0, this.warehouse_ids.length)
            this.start_date = ''
            this.end_date = ''
            this.currentPage = 1
            this.warehouseSelectKey += 1
            this.$nextTick(() => {
                if (this.$refs.warehouseSelect) {
                    this.$refs.warehouseSelect.clearSelection()
                }
            })
            this.fetchData()
        },
        async fetchData() {
            if (this.stockRequestInFlight) {
                return
            }
            this.stockRequestInFlight = true
            this.setLoading(true)
            try {
                const params = {
                    page: this.currentPage,
                    limit: this.limit,
                }

                if (this.warehouse_ids.length) {
                    params.warehouse_ids = this.warehouse_ids
                }

                if (this.start_date) {
                    params.start_date = this.start_date
                }

                if (this.end_date) {
                    params.end_date = this.end_date
                }

                const response = await this.$http.get(
                    '/tvd/monitoring/inventory',
                    { params }
                )

                this.tableData = response.data.data
                this.warehouses = response.data.warehouses
                this.totalPage = response.data.last_page
                this.lastUpdated = response.data.updated_at
                this.totalPerProduct = response.data.total_per_product || []
                this.stockLoadedPage = this.currentPage
            } catch (error) {
                this.handleError(error)
            } finally {
                this.setLoading(false)
                this.stockRequestInFlight = false
            }
        },
        async fetchMovement() {
            this.setLoading(true)
            try {
                const params = {}

                if (this.movementStartDate) {
                    params.start_date = this.movementStartDate
                }

                if (this.movementEndDate) {
                    params.end_date = this.movementEndDate
                }

                const productIds = this.movementSelectedProductIds()
                if (productIds.length) {
                    params.product_ids = productIds
                } else if (this.movementInitialLoad) {
                    // shortcut: hardcoded id of the default-selected product because
                    // the products list (mapping source) only arrives with the first
                    // response; upgrade to a dedicated products endpoint if product order/ids ever change.
                    params.product_ids = [2]
                }

                const response = await this.$http.get(
                    '/tvd/monitoring/daily-movement',
                    { params }
                )

                this.movementData = response.data.data
                this.movementProducts = response.data.products || []
                this.movementTotalAccumulated = response.data.total_accumulated || []
                this.movementLoaded = true

                if (this.movementInitialLoad) {
                    this.movementInitialLoad = false
                    if (!this.movementProductCodes.length && this.movementProducts.length > 1) {
                        this.movementProductCodes = [this.movementProducts[1]]
                    }
                }
            } catch (error) {
                this.handleError(error)
            } finally {
                this.setLoading(false)
            }
        },
        async handleMovementExport() {
            this.isMovementExporting = true
            this.setLoading(true)

            try {
                const params = {}

                if (this.movementStartDate) {
                    params.start_date = this.movementStartDate
                }

                if (this.movementEndDate) {
                    params.end_date = this.movementEndDate
                }

                const productIds = this.movementSelectedProductIds()
                if (productIds.length) {
                    params.product_ids = productIds
                }

                const response = await this.$http.post(
                    '/tvd/monitoring/export-daily-movement',
                    params,
                    { responseType: 'blob' }
                )

                const dateStr = this.$moment().format('DDMMYYYY')
                FileSaver.saveAs(response.data, `Daily_Movement_${dateStr}.xlsx`)
            } catch (error) {
                this.handleError(error)
            } finally {
                this.isMovementExporting = false
                this.setLoading(false)
            }
        },
        applyMovementFilter() {
            this.fetchMovement()
        },
        movementSelectedProductIds() {
            // products is an ordered code list; id = position (index + 1).
            if (!this.movementProductCodes.length || !this.movementProducts.length) {
                return []
            }
            return this.movementProductCodes
                .map((code) => this.movementProducts.indexOf(code) + 1)
                .filter((id) => id > 0)
        },
        resetMovementFilter() {
            this.movementProductCodes = this.movementProducts.length > 1 ? [this.movementProducts[1]] : []
            this.movementStartDate = ''
            this.movementEndDate = ''
            this.applyMovementFilter()
        },
        async refreshData() {
            this.setLoading(true)
            try {
                await this.$http.get('/tvd/monitoring/daily-base-qty')
            } catch (error) {
                this.handleError(error)
            } finally {
                this.setLoading(false)
                this.fetchData()
            }
        },
        async handleExport() {
            this.isExporting = true
            this.setLoading(true)

            try {
                const params = {}

                if (this.warehouse_ids.length) {
                    params.warehouse_ids = this.warehouse_ids
                }

                if (this.start_date) {
                    params.start_date = this.start_date
                }

                if (this.end_date) {
                    params.end_date = this.end_date
                }

                const response = await this.$http.post(
                    '/tvd/monitoring/export-excel',
                    params,
                    { responseType: 'blob' }
                )

                const warehouseName = this.getExportWarehouseName()

                const dateStr = this.$moment().format('DDMMYYYY')
                const filename = `Monitoring_${warehouseName}_${dateStr}.xlsx`

                FileSaver.saveAs(response.data, filename)
            } catch (error) {
                this.handleError(error)
            } finally {
                this.isExporting = false
                this.setLoading(false)
            }
        },
        handleStockPageChange() {
            if (this.currentPage !== this.stockLoadedPage) {
                this.fetchData()
            }
        },
        applyInspectionFilters() {
            this.inspectionCurrentPage = 1
            this.loadInspection()
        },
        resetInspectionFilters() {
            this.inspectionFilter.product_code = null
            this.inspectionFilter.start_date = ''
            this.inspectionFilter.end_date = ''
            this.inspectionCurrentPage = 1
            this.loadInspection()
        },
        handleInspectionPageChange() {
            if (this.inspectionCurrentPage !== this.inspectionLoadedPage) {
                this.loadInspection()
            }
        },
        refreshInspection() {
            this.inspectionLoadedPage = null
            this.loadInspection()
        },
        async handleInspectionExport() {
            this.isInspectionExporting = true
            this.setLoading(true)

            try {
                const params = {}

                if (this.inspectionFilter.start_date) {
                    params.start_date = this.inspectionFilter.start_date
                }
                if (this.inspectionFilter.end_date) {
                    params.end_date = this.inspectionFilter.end_date
                }
                if (this.inspectionFilter.product_code) {
                    params.product_code = this.inspectionFilter.product_code.product_code
                }

                const response = await this.$http.get(
                    '/tvd/inspection/monitoring-inspection/export',
                    { params, responseType: 'blob' }
                )

                const dateStr = this.$moment().format('DDMMYYYY')
                FileSaver.saveAs(
                    response.data,
                    `Inspection_Monitoring_${dateStr}.csv`
                )
            } catch (error) {
                this.handleError(error)
            } finally {
                this.isInspectionExporting = false
                this.setLoading(false)
            }
        },
        async loadInspection() {
            this.setLoading(true)
            try {
                const params = {
                    per_page: 20,
                    page: this.inspectionCurrentPage,
                }

                if (this.inspectionFilter.start_date) {
                    params.start_date = this.inspectionFilter.start_date
                }
                if (this.inspectionFilter.end_date) {
                    params.end_date = this.inspectionFilter.end_date
                }
                if (this.inspectionFilter.product_code) {
                    params.product_code = this.inspectionFilter.product_code.product_code
                }

                const response = await this.$http.get(
                    '/tvd/inspection/monitoring-inspection',
                    { params }
                )

                const resp = response.data
                this.inspectionData = resp.data || []
                this.inspectionTotalPage = resp.last_page || 1
                this.inspectionLoadedPage = this.inspectionCurrentPage

                // Summary per product: accumulated ready-to-ship from latest API contract.
                const totalPerProduct = resp.total_per_product || []
                this.inspectionSummary = totalPerProduct.map((item) => ({
                    product_code: item.product_code,
                    inspected: item.total_inspected_qty || 0,
                    ready: item.total_ready_to_ship || 0,
                    accumulated: item.total_accumulated_ready_to_ship || 0,
                }))

                // Populate product dropdowns from first load
                if (resp.products) this.inspectionProducts = resp.products
            } catch (error) {
                this.handleError(error)
            } finally {
                this.setLoading(false)
            }
        },
    },
}
</script>
